import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import DatePickerTextbox from "@/components/DatePickerTextbox.vue";
let BenefitsLevelModal = class BenefitsLevelModal extends Vue {
    //loads the level with the property levelId
    loadLevel() {
        this.$store
            .dispatch("getBenefitLevel", {
            userId: this.$props.employee.userId,
            benefitId: this.$props.benefitId,
        })
            .then((response) => {
            this.$data.selectedLevel = response.data;
            this.$data.loading = false;
        })
            .catch((err) => {
            window.errorHandler.logError(err, "components/BenefitsLevelModal.vue - loadLevel");
        });
    }
    //saves changes to the level
    saveLevel() {
        this.$store
            .dispatch("saveBenefitLevel", {
            level: this.$data.selectedLevel,
            userId: this.$props.employee.userId,
        })
            .then((result) => {
            this.$store.dispatch("ToastMessage", {
                type: "any",
                message: "Level saved",
            });
            this.$emit("close");
        })
            .catch((err) => {
            window.errorHandler.logError(err, "components/BenefitsLevelModal.vue - saveLevel");
        });
    }
    deleteBenefit(item) {
        this.$store
            .dispatch("deleteEmployeeBenefit", {
            userId: this.$props.employee.userId,
            benefitId: this.$props.benefitId,
        })
            .then((response) => {
            //this.loadUserLevels();
            this.$data.confirmDeleteLevelDialog = false;
            this.$store.dispatch("ToastMessage", {
                type: "any",
                message: "Level Removed",
            });
            this.$emit("close");
            //send reload event
            window.eventBus.$emit("reloadBenefitsForUser");
        })
            .catch((err) => {
            window.errorHandler.logError(err, "components/BenefitsLevelModal.vue - deleteLevel");
        });
    }
    //save the object and shows a confirm dialog to remove a level
    confirmRemoveLevel(item) {
        this.$data.levelToRemove = item;
        this.$data.confirmDeleteLevelDialog = true;
    }
};
BenefitsLevelModal = __decorate([
    Component({
        data() {
            return {
                trueVal: true,
                loading: true,
                addLevelDialog: false,
                confirmDeleteLevelDialog: false,
                theme: this.$store.getters.getTheme,
                selectedLevel: [],
                newLevelToAdd: {},
                levels: null,
                levelToRemove: null,
            };
        },
        props: ["employee", "benefitId"],
        mounted() {
            this.loadLevel();
        },
        computed: {
            showModal: {
                get() {
                    return this.$data.trueVal;
                },
                set(newValue) {
                    this.$data.trueVal = newValue;
                    if (this.$data.trueVal === false) {
                        this.$emit("close"); //we need to send the close event if the dialog is closed by clicking outside rather than on the button
                    }
                },
            },
        },
        methods: {
            close() {
                this.$emit("close");
            },
        },
        components: {
            DatePickerTextbox,
        },
    })
], BenefitsLevelModal);
export default BenefitsLevelModal;
